import React from 'react';
import { Filter as FilterAdmin, TextInput } from 'react-admin';

const choices = [
  { id: 'nenhuma', name: 'Nenhuma' },
  { id: 'unica', name: 'Única' },
  { id: 'duplicada', name: 'Duplicado' },
  { id: 'triplicada', name: 'Triplicado' },
  { id: 'mais-de-3', name: 'Mais de 3' },
];

const Filter = (props) => (
  <FilterAdmin {...props}>
    <TextInput label="Nome" source="nome" />
  </FilterAdmin>
);

export default Filter;
